import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import _objectSpread from "E:/Deepin/Projects/spring-activity/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { mapMutations, mapState } from "vuex";
import help from "../assets/js/help";
import bus from "vue3-eventbus";
export default {
  name: "ListItem",
  props: {
    item: {
      type: Object,
      default: {
        applicationId: "13",
        applicationNum: "6",
        applicationStatus: "1",
        coverImgUrl: "/d/file/custom/31223/image/202301/1673945458583447.jpg?w=506&h=506",
        endTime: "2023-01-31T17:50:00Z",
        gap: 2,
        goodsNum: "2",
        goodsPrice: "1500",
        id: "8",
        invitationNum: "0",
        inviteNum: "2",
        isMe: "1",
        startTime: "2023-01-16T16:45:00Z",
        status: "1",
        title: "酒店自助餐"
      }
    },
    index: {
      type: [Number || String],
      default: ""
    }
  },
  data: function data() {
    return {
      type: 0,
      dialogShow: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(["uid", "token", "time", "phone", "isTest", "totalIngral", "type", "activeIndex", "isSelected", "shareTitle", "shareDesc", "shareImage", "bannerImage"])), {}, {
    statusText: function statusText() {
      return ["已删除", "未审核", "开始任务", "不通过"][this.item.status - 0 + 1];
    },
    source: function source() {
      if (window.d1ev) {
        return 1;
      } else if (window.webkit) {
        return 2;
      } else {
        return 3;
      }
    },
    params: function params() {
      var _this$item = this.item,
          startTime = _this$item.startTime,
          id = _this$item.id,
          status = _this$item.status,
          addr = _this$item.addr;
      return {
        "targetId": id - 0,
        "platformSource": this.source,
        "time": this.time,
        "token": this.token,
        "uid": this.uid - 0
      };
    },
    shareUrl: function shareUrl() {
      var applicationId = this.item.applicationId;
      var mobile = this.phone;
      var uid = this.uid;

      var _applicationId = applicationId ? help.encode(applicationId) : "";

      var _mobile = mobile ? help.encode(mobile) : "";

      var _uid = mobile ? help.encode(uid) : "";

      if (this.uid && mobile && applicationId) {
        if (this.isTest) {
          return "https://d1ev-new.yiduyongche.com/spring-share/index.html?i=".concat(_mobile, "&a=").concat(_applicationId, "&u=").concat(_uid);
        } else {
          return "https://www.d1ev.com/special/spring-share/index.html?i=".concat(_mobile, "&a=").concat(_applicationId, "&u=").concat(_uid);
        }
      } else {
        console.log("参数缺失");
        return "";
      }
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations(["setUid", "setTotalIngral", "setAppInfo", "setIsSelected", "setType", "setActiveIndex"])), {}, {
    showDialog: function showDialog() {
      if (process.env.NODE_ENV === "development") {
        this.dialogShow = true;
      }

      console.log(process.env.NODE_ENV);

      if (!isInApp()) {
        help.openApp("");
        return;
      }

      this.dialogShow = true;
    },
    onClickCreate: function onClickCreate() {
      getUserInfo();

      if (process.env.NODE_ENV === "development") {
        registerUserInfo(JSON.stringify({
          uid: "9381",
          token: "7685ab80069ad50c464e1ecf1a38dd15",
          time: "1673961905",
          phone: "13467077567"
        }));
      }
    },
    shareFriends: function shareFriends() {
      var _document$querySelect;

      if (!isInApp()) {
        help.openApp("");
        return;
      }

      var param = {
        "title": this.shareTitle || document.title,
        "thumbImage": this.shareImage || "https://www.d1ev.com/special/circle/images/share-2.png",
        "description": this.shareDesc || ((_document$querySelect = document.querySelector("meta[name='description']")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content) || "",
        "url": this.shareUrl
      };
      console.log(param);
      param.url ? window.startShare(param) : "";
    },
    doJoinActivity: function doJoinActivity() {
      if (this.uid) {
        this.joinActivity();
      } else {
        this.setType(3);
        console.log("buslisten");
        bus.on("joinActivity", this.joinActivity);
        this.onClickCreate();
      }
    },
    joinActivity: function joinActivity() {
      var _this = this;

      this.axios.post("/api/activity/invitation-add", JSON.stringify(this.params), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (res) {
        if (res) {
          help.requestSuccess(res).then(function (res) {
            console.log(res);
            console.log("updateIndex");

            _this.setActiveIndex(1);

            _this.setIsSelected(_this.index.toString());

            bus.off("joinActivity", _this.joinActivity);
          }, function (err) {
            console.log(err);

            _this.setActiveIndex(1);

            _Notify({
              type: "warning",
              message: err
            });

            help.resError(err, true, _this.logout, _this.setTimeOut);
          });
        }
      }, function (err) {
        help.requestError(err);
      });
    },
    onClickList: function onClickList(item) {}
  }),
  mounted: function mounted() {}
};